import { Link } from '@tanstack/react-router'

import { Card } from '@/shared/ui/Card'

/**
 * Quem não declarou interesse não recebe lista vazia nem lista aleatória: recebe
 * o convite, com acesso direto ao seletor de tags do perfil.
 */
export const ColdStartInvite = ({ compact = false }: { compact?: boolean }) => (
  <Card className={compact ? 'p-4' : 'p-6'}>
    <p className="text-base font-semibold text-foreground">
      Conte o que você busca no evento
    </p>

    <p className="mt-1 text-base text-gray-700">
      Ao escolher seus interesses, passamos a sugerir pessoas, empresas, palestras
      e trilhas com algo em comum com você.
    </p>

    {/* ACCESSIBILITY §2.2: rótulo de botão tem piso de 16px e peso ≥600. */}
    <Link
      to="/minha-conta/networking"
      className="mt-4 inline-flex min-h-[var(--target-min)] items-center justify-center rounded-full bg-primary px-5 text-base font-semibold text-primary-foreground"
    >
      Escolher meus interesses
    </Link>
  </Card>
)
